import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteOrganization } from "../../services/organization";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function OrganizationDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Organization ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/organization");
  };

  return (
    <>
      <Confirm
        header={locale.get("organization.confirmDelete")}
        loading={loading}
        onClose={closeModal}
        onConfirm={() => {
          (async () => {
            setLoading(true);
            try {
              await deleteOrganization(id);
              await queryClient.invalidateQueries({
                queryKey: ["organizations"],
              });
            } finally {
              setLoading(false);
              closeModal();
            }
          })();
        }}
      />
    </>
  );
}
